import { useContext } from "react";
import { IconButton } from "@livingmap/hippo";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { MapContext } from "../Map/Map";
import { useClickOutside } from "hooks/useClickOutside";

import AnchoredDialog from "components/AnchoredDialog/AnchoredDialog";
import Button from "components/Button/Button";

import styles from "./ShareToMobile.module.scss";

export interface ShareToMobileProps {
  shortlinkUrl: string;
  onClose: () => void;
  onButtonClick: () => void;
  isDialogOpen?: boolean;
}

export default function ShareToMobile({
  shortlinkUrl,
  onClose,
  onButtonClick,
  isDialogOpen,
}: ShareToMobileProps) {
  const { controlTheme } = useContext(MapContext);
  const { t } = useTranslation();

  useClickOutside(styles.container, onClose);
  return (
    <div className={styles.container}>
      <Button
        dataQA="share-to-mobile-button"
        onClick={onButtonClick}
        label={t("share_to_mobile.share_button_text")}
        color="black"
        {...(controlTheme === "light" && {
          outlined: true,
        })}
        leftIcon="ShareIcon"
        rounded
        theme={controlTheme}
      />
      {isDialogOpen && (
        <AnchoredDialog className={styles.dialog} dataQA="share-dialog">
          <div
            data-qa="share-to-mobile-dialog-content"
            className={classNames(styles.dialogContent, styles[controlTheme])}
          >
            <QRCode value={shortlinkUrl} className={styles.qrCode} />
            <p className={styles.description}>
              <span>{t("share_to_mobile.share_line_1")}</span>
              <span>{t("share_to_mobile.share_line_2")}</span>
            </p>
            <IconButton
              dataQA="share-dialog-close-button"
              iconSize={24}
              size="large"
              type="primary"
              icon="close"
              className={styles.closeBtn}
              onClick={onClose}
            />
          </div>
        </AnchoredDialog>
      )}
    </div>
  );
}
